import { ALGOLIA_FACETS, AND_OPERATOR, PUBLICATION_TYPES } from "@/modules/jobAds/client/constants"

export const enabledAlgoliaSponsoredFiltersRules = (facetFilters: string): string => {
  return `${facetFilters} ${AND_OPERATOR} (${ALGOLIA_FACETS.SCORE}:${PUBLICATION_TYPES.FLASH_OR_SPONSORED})`
}
